var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"webinar-media-content-wrapper"},[(!_vm.webcast.enableVOD)?_c('AudioPlayer2'):_vm._e(),(_vm.webcast.enableVOD)?_c('AudioPlayerVOD'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }